<template>
  <div class="notice-box">
    <!-- <el-button type="text" @click="viewMore">更多</el-button> -->
    <el-tabs type="card">
      <el-tab-pane label="公告">
        <template v-if="notices.length">
          <div class="notice-box__item" v-for="(item,index) in notices" :key="index" @click="open(item,0)">
            <div class="notice-box__item__title">{{item.Title}}</div>
            <div class="notice-box__item__content">{{noticeContent(item.Content)}}</div>
            <div class="notice-box__item__time">
              <div>{{item.UpdateTime | dayFormat('YYYY-MM-DD HH:mm:ss')}}</div>
              <div @click.stop="open(item,0)" class="notice-box__item__action"><i
                  class="el-icon-view"></i>{{item.DetailCount}}</div>
            </div>
          </div>
        </template>
        <div class="notice-box__empty" v-else>暂无公告信息</div>
        <div class="notice-box__footer" @click="commonNotice">查看更多 >></div>
      </el-tab-pane>
      <el-tab-pane label="重要通知">
        <template v-if="pNotices.length">
          <div class="notice-box__iteration" v-for="(item,index) in pNotices" :key="`p_${index}`" @click="open(item,1)">
            <div class="notice-box__iteration__title">{{item.Title}}</div>
            <div class="notice-box__iteration__time">
              <div>{{item.UpdateTime | fromNow}}</div>
              <div @click.stop="open(item,1)" class="notice-box__item__action"><i
                  class="el-icon-view"></i>{{item.DetailCount}}</div>
            </div>
          </div>
        </template>
        <div class="notice-box__empty" v-else>暂无更新日志信息</div>
        <div class="notice-box__footer" @click="significanceNotice">查看更多 >></div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { openNavUrl, tool } from '@/utils'
import { mapGetters } from 'vuex'
export default {
  name: 'headerNotice',
  props: {
    ejectGZH: { // 是否弹出公众号弹窗提示
      type: Boolean,
      default: () => true
    }
  },
  data () {
    return {
      notices: [],
      pNotices: [],
      gzhData: {}
    }
  },
  created () {
    this.getNoticeForIndex().then(() => {
      // const pathname = location.pathname //pathname === '/home' &&
      // if (this.notices && this.notices.length) {
      //   let item = this.notices[0]
      //   let customerIds = item.CustomerIds
      //   if (item.IsBox === 1 && !customerIds.includes(this.userInfo.CustomerId)) { // 表示未读
      //     // this.open(item, 0)
      //   } else {
      //     /* this.ejectGZH && this.getNotBindNotice().then(data => {
      //       this.$emit('gzh', data)
      //     }) */
      //     this.ejectGZH && (this.$emit('gzh', this.gzhData))
      //   }
      // } else {
      //   /* this.ejectGZH && this.getNotBindNotice().then(data => {
      //     this.$emit('gzh', data)
      //   }) */
      //   this.ejectGZH && (this.$emit('gzh', this.gzhData))
      // }
    })
  },
  computed: {
    ...mapGetters([
      'CUSTOMER_LOGINCUSTOMER'
    ]),
    userInfo () {
      return this.CUSTOMER_LOGINCUSTOMER.data
    }
  },
  methods: {
    open (item, type) {
      item.type = type
      // this.$emit('open', item)
      this.addNoticeDetail(item)
    },
    getNoticeForIndex () {
      return this.$store.dispatch('noticeGetNoticeForIndex').then(({ data }) => {
        this.notices = (data.Notice || []).filter((item, index) => index < 5)
        this.pNotices = (data.Pnotice || []).filter((item, index) => index < 5)
        this.gzhData = {
          Notices: data.NotBindNotice || []
        }
      })
    },
    getNotBindNotice () {
      return this.$store.dispatch('noticeGetNotBindNotice').then(data => {
        console.log(data)
        // this.dynamic.items = data.Notices || []
        return data
      })
    },
    viewMore () {
      openNavUrl('/Partner/Notice')
    },
    commonNotice () {
      let host = window.location.origin
      openNavUrl('/announcement/commonExamine', '公告查看', host, 'blank', false)
    },
    significanceNotice () {
      let host = window.location.origin
      openNavUrl('/announcement/significanceInform', '重要公告', host, 'blank', false)
    },
    noticeContent (value) {
      let str = tool.removeHtmlTag(value)
      return str.length > 10 ? `${str.substr(0, 10)}...` : str
    },
    addNoticeDetail (item) {
      let params = {
        noticeId: item.NoticeId
      }
      return this.$store.dispatch('noticeAddNoticeDetail', params).then(() => {
        this.$emit('open', item)
      })
    }
  }
}
</script>

<style lang="less">
@import url(../assets/less/color.less);
.notice-box {
  font-size: 14px;
  &__item {
    padding: 0 15px 5px 15px;
    line-height: 20px;
    & + & {
      border-top: 1px solid @border-color;
      padding-top: 10px/2;
    }
    &__title {
      max-width: 200px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    &__time {
      font-size: 12px;
      display: flex;
      justify-content: space-between;
    }
    &__action {
      cursor: pointer;
    }
  }
  &__empty {
    text-align: center;
  }
  &__footer {
    border-top: 1px solid @border-color;
    text-align: right;
    padding-top: 8px;
    padding-right: 15px;
    font-size: 12px;
    color: #b3b3b3;
    cursor: pointer;
  }
  .el-icon-view {
    margin: 0 3px;
  }
  &__iteration {
    padding: 0 15px 5px 15px;
    line-height: 25px;
    & + & {
      border-top: 1px solid @border-color;
      padding-top: 5px;
    }
    &__time {
      display: flex;
      justify-content: space-between;
    }
  }
  .el-button {
    position: absolute;
    right: 10px;
    z-index: 100;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Notice.vue